import { render, staticRenderFns } from "./TestPackageDetailCardstack.vue?vue&type=template&id=55c4f7ac"
import script from "./TestPackageDetailCardstack.vue?vue&type=script&lang=js"
export * from "./TestPackageDetailCardstack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports